<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="ml-2 elevation-0 normal-btn-text rounded-tag-small">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="criarCompra" v-if="hasRoleComprador">
        <v-list-item-icon>
          <v-icon>mdi-shopping</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Criar compra
        </v-list-item-content>
      </v-list-item>
      <px-cancelar-dialog
        texto-botao="Cancelar solicitação"
        :titulo="getTitulo"
        :descricao="getDescricao"
        @cancelar-dialog="onClickCancelar"
        :disabled="!canCancelRequisicao"/>
      <v-list-item @click="finalizar" v-if="hasRoleComprador">
        <v-list-item-icon>
          <v-icon>mdi-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Finalizar solicitação
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="editRequisicao" v-if="hasRoleRequisicao"
       :disabled="!isEditavel || bloquearEdicaoOuCopia">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Editar solicitação
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="copyRequisicao" v-if="hasRoleRequisicao"
       :disabled="isRascunho || bloquearEdicaoOuCopia">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Copiar solicitação
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import { SituacaoRequisicao } from 'px-business-components';

export default {
  props: {
    requisicao: Object,
    hasRoleComprador: Boolean,
    hasRoleRequisicao: Boolean,
    bloquearEdicaoOuCopia: Boolean,
  },
  computed: {
    isEditavel() {
      return SituacaoRequisicao.keys.RECEBIDA.key === this.requisicao.situacao;
    },
    isRascunho() {
      return SituacaoRequisicao.keys.RASCUNHO.key === this.requisicao.situacao;
    },
    canCancelRequisicao() {
      return this.hasRoleComprador || (this.hasRoleRequisicao && this.isEditavel);
    },
    getTitulo() {
      return 'Cancelar solicitação';
    },
    getDescricao() {
      return `A solicitação "${this.requisicao.identificador}" será cancelada e a operação não poderá ser desfeita.`;
    },
  },
  methods: {
    finalizar() {
      RequisicoesService.finalizar(this.requisicao.id)
        .then(() => {
          this.emitUpdate();
        });
    },
    onClickCancelar(motivoRecusa) {
      RequisicoesService.cancelar(this.requisicao.id, { motivoRecusa })
        .then(() => {
          this.emitUpdate();
        });
    },
    criarCompra() {
      this.$router.push({
        name: 'main.compras.requisicao-compra',
        query: {
          idRequisicao: this.requisicao.id,
        },
        params: {
          isRascunho: false,
        },
      });
    },
    editRequisicao() {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: this.requisicao.id,
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    copyRequisicao() {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: this.requisicao.id,
          isRascunho: false,
          isCopy: true,
        },
      });
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
